function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-858.000000, -195.000000)",
  fill: "#707071",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M878,202.24 L870.81,201.62 L868,195 L865.19,201.63 L858,202.24 L863.46,206.97 L861.82,214 L868,210.27 L874.18,214 L872.55,206.97 L878,202.24 Z M868,208.4 L864.24,210.67 L865.24,206.39 L861.92,203.51 L866.3,203.13 L868,199.1 L869.71,203.14 L874.09,203.52 L870.77,206.4 L871.77,210.68 L868,208.4 Z"
})));

function SvgIconUnstarred(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20"
  }, props), _ref);
}

export default __webpack_public_path__ + "dc891582885bdb4e544b30e636e5282c.svg";
export { SvgIconUnstarred as ReactComponent };